import { FriendlyError } from '@/components/FriendlyError';

export function NotFoundPage() {
  return (
    <FriendlyError
      eyebrow="404"
      title="Page not found"
      description="That page doesn't exist or has moved. The safest next stop is your current trip, Explore, or the landing page."
      actions={[
        { label: 'Current trip', href: '/trips/active', variant: 'primary' },
        { label: 'Explore', href: '/explore' },
        { label: 'Home', href: '/' },
      ]}
    />
  );
}
